export enum TipoNotificacao {
    sucesso,
    erro,
    info,
    alerta
}